export default __webpack_public_path__ + "static/media/past_photo_02.51049567.png";